import React, { useRef, useState, useEffect } from "react";
import { useFormikContext } from "formik";
import styles from "./styles.module.scss";
import PlaceholderLogoIcon from "../../../../../../assets/svg/icons/common/placeholder-logo";

export const AddLogo = ({ imageSrc }) => {
  const { setFieldValue } = useFormikContext();
  const fileInputRef = useRef(null);
  const [src, setSrc] = useState(imageSrc);

  const handleOnFileChange = (event) => {
    if (event.target.files[0]) {
      setFieldValue("fileToUpload", event.target.files[0]);
      setSrc(URL.createObjectURL(event.target.files[0]));
    }
  };

  const handleRemoveLogo = () => {
    setSrc(null);
    setFieldValue("fileToUpload", "");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    setSrc(imageSrc);
  }, [imageSrc]);

  return (
    <div
      className={`${styles.orgLogoContainer} ${src ? styles.logoSet : styles.placeHolderSet}`}
    >
      <div className={styles.orgLogoImageContainer}>
        {src ? <img src={src} alt="" onError={() => setSrc("")} /> : <PlaceholderLogoIcon />}
        <div className={styles.shadow}></div>
      </div>
      <div className={styles.inputLabelContainer}>
        <label htmlFor="fileToUpload">
          <p className={styles.title}>
            Add logo <span>(optional)</span>
          </p>
          <input
            id="fileToUpload"
            name="fileToUpload"
            type="file"
            ref={fileInputRef}
            className={styles.fileInput}
            onChange={handleOnFileChange}
          />
        </label>
        {src && (
          <span onClick={handleRemoveLogo} className={styles.removeLogo}>
            Remove
          </span>
        )}
      </div>
    </div>
  );
};

export default AddLogo;
